module.exports = __webpack_public_path__ + "static/media/manage_relation.a65f11d2.png";